import { render, staticRenderFns } from "./CompleteProposalHome.vue?vue&type=template&id=97c04798&scoped=true&"
import script from "./CompleteProposalHome.vue?vue&type=script&lang=js&"
export * from "./CompleteProposalHome.vue?vue&type=script&lang=js&"
import style0 from "./CompleteProposalHome.vue?vue&type=style&index=0&id=97c04798&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c04798",
  null
  
)

export default component.exports